import * as THREE from 'three'

import Config from '@glass-designer/config'
import BaseObject from './baseObject'
import MathsUtils from '@/utils/mathsUtils'
import GlassDesignerTypes from '../types'


// Editing Item
// A panel item object in the scene to display a panel item when dragging into the scene from the library
export default class EditingItem extends BaseObject {
  constructor(editor, options = {}) {
    super(editor)

    this.position = new THREE.Vector2(0, 0)
    this.angle = 0    // Degrees

    // Datum links used while editing
    // Used to update the dynamic dimensions while adding/moving the panel item
    this.datumLinks = []

    this.outlineShapeObj = null
    this.outlineGeometry = null
    this.objectGeometry = null
    this.shapeObj = null

    this.sceneObject = new THREE.Object3D()
  }

  // onBeforeRender
  // Called prior to rendering of the object
  onBeforeRender() {
    super.onBeforeRender()

    let angleRads = MathsUtils.degreesToRadians(this.angle)
    let objAngles = new THREE.Euler(0, 0, angleRads)

    if(this.shapeObj) {
      this.shapeObj.position.set(this.position.x, this.position.y, 99)
      this.shapeObj.setRotationFromEuler(objAngles)
    }
    if(this.outlineShapeObj) {
      this.outlineShapeObj.position.set(this.position.x, this.position.y, 99)
      this.outlineShapeObj.setRotationFromEuler(objAngles)
    }
  }


  // Update the position of the cutout
  setPosition(pos) {
    this.position.set(pos.x, pos.y)
  }

  // Update the rotation
  // In degrees
  setRotation(angle) {
    this.angle = angle
  }

  // Set the datum links
  setDatumLinks(links) {
    this.datumLinks = links
  }


  /**
   * Build the item info from a details based on the library item
   */
  buildFromLibraryItemInfo(libraryItemInfo) {
    let itemData = libraryItemInfo.itemData || {}

    this.clear()

    var texture = null
    if(libraryItemInfo.id)
      texture = this.editor.loadEditorLibraryItemTextureSync(libraryItemInfo.id)

    let width = parseInt(itemData.width || 100)
    let height = parseInt(itemData.height || 50)

    // Outline
    var vertices = []
    vertices.push(-width / 2, -height / 2, 0, width / 2, -height / 2, 0)
    vertices.push(width / 2, -height / 2, 0, width / 2, height / 2, 0)
    vertices.push(width / 2, height / 2, 0, -width / 2, height / 2, 0)
    vertices.push(-width / 2, height / 2, 0, -width / 2, -height / 2, 0)

    this.outlineGeometry = new THREE.BufferGeometry()
    this.outlineGeometry.setAttribute( 'position', new THREE.Float32BufferAttribute(vertices, 3))

    var outerMaterial = new THREE.LineBasicMaterial({
      color: this.editor.getTheme().editingOutlineColour,
      transparent: true,
      opacity: this.editor.getTheme().editingOutlineOpacity
    })
    this.outlineShapeObj = new THREE.LineSegments(this.outlineGeometry, outerMaterial)
    this.sceneObject.add(this.outlineShapeObj)
    
    this.objectGeometry = new THREE.BoxGeometry(width, height, 5)
    let objectMaterial = new THREE.MeshBasicMaterial({
      map: texture,
      color: '#FFFFFF',
      transparent: true,
      opacity: 0.5,
      depthWrite: false,
      depthTest: false
    })

    this.shapeObj = new THREE.Mesh(this.objectGeometry, objectMaterial)
    this.shapeObj.scale.x = -1    // Flip around for the texture adjustment
    this.shapeObj.scale.y = -1
    this.sceneObject.add(this.shapeObj)
  }


  clear() {
    this.clearSceneObject()

    if(this.objectGeometry)
      this.objectGeometry.dispose()
    if(this.outlineGeometry)
      this.outlineGeometry.dispose()

    this.shapeObj = null
    this.outlineShapeObj = null
    this.objectGeometry = null
    this.outlineGeometry = null
  }



}
